<template> 
	<div id="app">  		   
		<notifications group="foo" />
		<div class="container-fluid">
		  <div class="row-fluid">        
			  <hello></hello>		  
			</div>
			<div class="span10">
			  <list></list>
			</div>
		  </div>
		</div>
	</div> 	
</template>

<script>
import Hello from "./components/Hello";
import List from "./components/List";

export default {
  name: "app",
  components: {
    Hello, 
	List
  }
};

</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.span10 {
	padding-left:400px;
}

li.nav-item {
	width: 300px;
}
</style>

